import React, {useEffect,Fragment,memo, useState, useRef} from 'react'
import { Navbar,Container,Nav,Dropdown, Form} from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import CustomToggle from '../../../dropdowns';
import { ROUTES } from '../../../../utilities/constant';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { postApiCall, getApiCall } from '../../../../service/httpCall';
import { API_USER_LOGOUT, API_USERS_PROFILE , API_USER_LOGIN_AS, API_USER_LOGOUT_FROM, API_BREAK_LIST,
  USER_BREAKS_EDIT, API_AGENT_SCHEDULE, USER_BREAKS_CREATE,
  API_COMPANY_PROFILE} from '../../../../service/url';
import {Row,Col, Modal} from 'react-bootstrap'
import { Button } from 'primereact/button';
import avatars1 from '../../../../assets/images/avatars/01.png'
import avatars2 from '../../../../assets/images/avatars/avtar_1.png'
import avatars3 from '../../../../assets/images/avatars/avtar_2.png'
import avatars4 from '../../../../assets/images/avatars/avtar_3.png'
import avatars5 from '../../../../assets/images/avatars/avtar_4.png'
import avatars6 from '../../../../assets/images/avatars/avtar_5.png'
import avatars7 from '../../../../assets/images/avatars/superAdminAvatar.jpg'
import avatars8 from '../../../../assets/images/avatars/blackAvatar.jpg'
import avatars9 from '../../../../assets/images/avatars/blueAvatar.jpg'
import avatars10 from '../../../../assets/images/avatars/corelAvatar.jpg'
import avatars11 from '../../../../assets/images/avatars/greenAvatar.jpg'
import avatars12 from '../../../../assets/images/avatars/pinkAvatar.jpg'
import avatars13 from '../../../../assets/images/avatars/yellowAvatar.jpg'
import Logo from '../../components/logo'
import { useSelector } from 'react-redux';
import * as SettingSelector from '../../../../store/setting/selectors'
import { logoutUser, switchBack, switchBackUser } from '../../../../utilities/setting';
import { USER_ROLES_MAP_PROFILE, USER_ROLES } from '../../../../utilities/constant';
import { clearUser } from "../../../../store/setting/actions";
import ToastNotification from '../../../../components/Toast';
import "../../../../assets/custom/css/toggle.css"
import { Display, ArrowClockwise } from 'react-bootstrap-icons';
import { IoCall } from "react-icons/io5";
import { FaHistory, FaWpforms, FaSignOutAlt, FaRegUser, FaRegPauseCircle, FaChevronLeft, FaChevronRight, FaCheck, FaClock, FaExclamationTriangle, FaMinus } from "react-icons/fa";
import { FaTasks } from "react-icons/fa";
import { toast } from 'react-toastify';

// PROFILE ICON BASED ON USER ROLE:
// SUPERADMIN -> MULTICOLOR
// SUB SUPERADMIN -> BLACK
// RESELLER -> BLUE / LIGHT BLUE
// COMPANY -> COREL / LIGHT ORANGE
// CALL CENTER -> GREEN / LIGHT GREEN
// CALL CENTER TEAMLEAD -> PINK
// AGENT -> YELLOW / LEMON

const Header = memo((props) => {
    const [showBreakModal, setShowBreakModal] = useState(false);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [isRefreshingCredits, setIsRefreshingCredits] = useState(false);

  const handleShow = () => setShowBreakModal(true);
  const handleClose = () => setShowBreakModal(false);
  const [selectedBreakId, setSelectedBreakId] = useState("");

    const navigate = useNavigate();
    const navbarHide = useSelector(SettingSelector.navbar_show); 
    const headerNavbar = useSelector(SettingSelector.header_navbar);
    const userRoleId = useSelector(SettingSelector.userRole);

    // State for userName, userRole and userCredits
    const [userName, setUserName] = useState('');
    const [userRoleLabel, setUserRoleLabel] = useState('');
    const [userCredits, setUserCredits] = useState(0);
    const [ttsCredits, setTtsCredits] = useState(0);
    const [userId, setUserId] = useState(null);
    const [breaksData, setBreaksData] = useState([]);
    const [countdown, setCountdown] = useState(null);

    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const [showCompanyInAvailableCreditsHeading, setShowCompanyInAvailableCreditsHeading] = useState(false);

    const [hideForCallCenter, setHideForCallCenter] = useState(false);
    const [showModal, setShowModel] = useState(false)
    const [activeType, setActiveType] = useState(null);
    const [activeModal, setActiveModal] = useState("");
    const [activeModals, setActiveModals] = useState([]);
    const [showToast, setShowToast] = useState(false);
    const [toastProps, setToastProps] = useState(null);
    const [types, setTypes] = useState([])
    const [loggedInUserRole, setLoggedInUserRole] = useState(null);
    const [loggedInUserDetail, setLoggedInUserDetail] = useState({});
    const [agentGroups, setAgentGroups] = useState([]);
    const [showQueueTooltip, setShowQueueTooltip] = useState(false); // hover state
    const [queuePage, setQueuePage] = useState(0);
    const pageSize = 2;
    const totalPages = Math.ceil(agentGroups.length / pageSize);
    const [userStatus, setUserStatus] = useState("AVAILABLE"); 
    const [dotColor, setDotColor] = useState('green'); 
    const [breakExceeded, setBreakExceeded] = useState(false);
    const [breakEndTime, setBreakEndTime] = useState(null);
    const [profileIcon, setProfileIcon] = useState(avatars1);

    const [loginTime, setLoginTime] = useState(0); // seconds
    const [idleTime, setIdleTime] = useState(0);


    const timerRef = useRef(null);
    const loginTsRef = useRef(null);
    const idleTsRef = useRef(null); 


    useEffect(() => {
      const loadTimers = async () => {
        if (!loggedInUserRole) return;

        const now = Date.now();

        let loginTimestamp = await AsyncStorage.getItem('loginTimestamp');
        let idleTimestamp = await AsyncStorage.getItem('idleTimestamp');

        if (!loginTimestamp) {
          loginTimestamp = now.toString();
          await AsyncStorage.setItem('loginTimestamp', loginTimestamp);
        }
        
        if (!idleTimestamp) {
          idleTimestamp = now.toString();
          await AsyncStorage.setItem('idleTimestamp', idleTimestamp);
        }

        loginTsRef.current = parseInt(loginTimestamp);
        idleTsRef.current = parseInt(idleTimestamp);

        startTimers();

        
      };

      loadTimers();

      return () => {
        if (timerRef.current) {
          clearInterval(timerRef.current);
          timerRef.current = null;
        }
      };
    }, [loggedInUserRole]);

    const startTimers = () => {
      if (timerRef.current) return; // prevent multiple intervals

      timerRef.current = setInterval(() => {
        const now = Date.now();

        setLoginTime(Math.floor((now - loginTsRef.current) / 1000));
        setIdleTime(Math.floor((now - idleTsRef.current) / 1000));
      }, 1000);
    };

   

    const durationToSeconds = (duration) => {
      const minutes = parseInt(duration, 10);
      return minutes * 60;
    };

    useEffect(() => {
      if (userStatus !== "BREAK" || !breakEndTime) return;

      const timer = setInterval(() => {
        const remaining = Math.floor((breakEndTime - Date.now()) / 1000);

        if (remaining <= 0) {
          setCountdown(0);
          setBreakExceeded(true);
          clearInterval(timer);
        } else {
          setCountdown(remaining);
        }
      }, 1000);

      return () => clearInterval(timer);
    }, [userStatus, breakEndTime]);


    useEffect(() => {
      let isMounted = true;
      if (!loggedInUserDetail?.agentData?.id) return ;
      const fetchAgentGroups = async () => {
        try {
          const resp = await getApiCall(
            `${API_AGENT_SCHEDULE}/${loggedInUserDetail?.agentData?.id}`
          );

          if (isMounted) {
            setAgentGroups(resp?.groups || []);
          }
        } catch (err) {
          if (isMounted) setAgentGroups([]);
        }
      };

      fetchAgentGroups();

      return () => {
        isMounted = false;
      };
    }, [
      loggedInUserRole?.role,
      loggedInUserDetail?.agentData?.id
    ]);


    useEffect(() => {
      if (showQueueTooltip) setQueuePage(0);
    }, [showQueueTooltip]);

    const paginatedGroups = agentGroups.slice(
      queuePage * pageSize,
      queuePage * pageSize + pageSize
    );

    const hasPrev = queuePage > 0;
    const hasNext = queuePage < totalPages - 1;


    const formatTime = (secs) => {
      const minutes = String(Math.floor(secs / 60)).padStart(2, "0");
      const seconds = String(secs % 60).padStart(2, "0");
      return `${minutes}:${seconds}`;
    };

  const handleConfirm = async () => {
  if (!selectedBreakId) {
          toast.error("Please select a break");
    return;
  }

  try {
    const resp = await postApiCall(USER_BREAKS_CREATE, { reason: selectedBreakId });
    const selectedBreak = breaksData.find((b) => b.id == selectedBreakId);
    const seconds = durationToSeconds(Number(selectedBreak.duration));

   // Get existing data from AsyncStorage
    const existingData = await AsyncStorage.getItem("activeBreak");
    let breakArray = [];

    // Parse existing data safely
    if (existingData) {
      try {
        const parsedData = JSON.parse(existingData);
        if (Array.isArray(parsedData)) {
          breakArray = parsedData;
        } else if (parsedData) {
          breakArray = [parsedData];
        }
      } catch (e) {
        console.error("Error parsing activeBreak:", e);
        breakArray = [];
      }
    }

    const endTime = Date.now() + seconds * 1000;
    // Add new break object
    breakArray.push({
      breakData: resp?.userBreaks,
      endTime: Date.now() + seconds * 1000,
      user_id: resp?.userBreaks?.user_id
    });

    setBreakEndTime(endTime);

    // Save back to AsyncStorage
    await AsyncStorage.setItem("activeBreak", JSON.stringify(breakArray));

    setCountdown(seconds);
    setUserStatus("BREAK")
    handleClose();
          toast.success("Break Status Applied");
  } catch (error) {
    console.log("error while updating user break status", error);

          toast.error(error || `Error while Applying Break`);
    setShowToast(true);
  }
};

const cancelBreak = async () => {
  if (!userId) {
   
          toast.error("User Id Not Found");
    return;
  }
  try {
    const url = USER_BREAKS_EDIT.replace(":id", userId);
    await postApiCall(url);
    // remove fron asyncStotage

    const existingData = await AsyncStorage.getItem("activeBreak");
    if (existingData) {
      let breakArray = JSON.parse(existingData);

      breakArray = breakArray.filter(b => b.user_id !== userId);

      if (breakArray.length > 0) {
        await AsyncStorage.setItem("activeBreak", JSON.stringify(breakArray));
      } else {
        await AsyncStorage.removeItem("activeBreak");
      }
    }

    setCountdown(null);
    setShowCancelModal(false);
    setSelectedBreakId(null);
    setUserStatus('AVAILABLE');
    setBreakExceeded(false);
          toast.success("Break cancelled");
  } catch (error) {
    console.log("error while updating user break status", error);
          toast.error(error || `Error while Cancelling Break`);
    setShowToast(true);
  }
};


const checkAndRestoreBreak = async () => {
  const breakDataStorage = await AsyncStorage.getItem("activeBreak");
  const user = JSON.parse(await AsyncStorage.getItem("user"));

  if (!breakDataStorage) return;

  try {
    const breakArray = JSON.parse(breakDataStorage);

    const userBreak = breakArray.find(
      b => b.user_id === user?.id
    );

    if (!userBreak) return;

    const { breakData, endTime } = userBreak;
    const remainingSeconds = Math.floor((endTime - Date.now()) / 1000);

    setUserStatus("BREAK");
    setSelectedBreakId(breakData.id);
    setBreakEndTime(endTime);

    if (remainingSeconds > 0) {
      setCountdown(remainingSeconds);
      setBreakEndTime(endTime);
      setBreakExceeded(false);
    } else {
      // Break time exceeded
      setCountdown(0);
      setBreakExceeded(true);
    }

  } catch (e) {
    console.error("Error restoring break state:", e);
    setUserStatus("AVAILABLE");
  }
};



const refreshCredits = async () => {
    if (isRefreshingCredits) return;
    setIsRefreshingCredits(true);
    try {
      const rawUser = await AsyncStorage.getItem('user');
      if (!rawUser) {
        console.error("User data not found in AsyncStorage");
        return;
      }

      const user = JSON.parse(rawUser);

      // if(user.id && user?.role === USER_ROLES.COMPANY_ADMIN) {
      //   let apiUrl = API_USERS_PROFILE.replace(":id", user.id);
      //   const resp = await getApiCall(apiUrl, {});
      //   setTtsCredits(resp?.tts_credits || "0.00");
      // }

      if(user.id && (user?.role === USER_ROLES.COMPANY_ADMIN || user?.role === USER_ROLES.RESELLER || user?.role === USER_ROLES.CALL_CENTRE_ADMIN)) {
        let apiUrl = API_COMPANY_PROFILE.replace(":id", user?.assignedCompany?.id);
        const resp = await getApiCall(apiUrl, {});
        setUserCredits(resp?.credits_available || "0.00");
        setTtsCredits(resp?.tts_credits || "0.00");
      } 
      // else {
      //   setUserCredits(user?.company?.credits_available || "0.00");
      // }

    }catch (error) {
      console.error("Error refreshing credits:", error);
      toast.error("Failed to refresh credits");
    } finally {
      setIsRefreshingCredits(false);
    }
  };



    useEffect(() => {
        // Initial fetch from AsyncStorage
        const fetchUserData = async () => {
            const rawUser = await AsyncStorage.getItem('user');
          
            if (!rawUser) {
              console.error("User data not found in AsyncStorage");
              return;
            }
          
            let user;
            try {
              user = JSON.parse(rawUser);
            } catch (e) {
              console.error("Invalid JSON in AsyncStorage user:", e);
              return;
            }

            if (user && user?.role) {
              if (user?.role === USER_ROLES.SUPERADMIN) {
                setProfileIcon(avatars7);
              } else if (user?.role === USER_ROLES.SUB_SUPERADMIN) {
                setProfileIcon(avatars8);
              } else if (user?.role === USER_ROLES.RESELLER) {
                setProfileIcon(avatars9);
              } else if (user?.role === USER_ROLES.COMPANY_ADMIN) {
                setProfileIcon(avatars10);
              } else if (user?.role === USER_ROLES.CALL_CENTRE_ADMIN) {
                setProfileIcon(avatars11);
              } else if (user?.role === USER_ROLES.CALL_CENTRE_TEAM_LEAD) {
                setProfileIcon(avatars12);
              } else if (user?.role === USER_ROLES.CALL_CENTRE_AGENT) {
                setProfileIcon(avatars13);
              } else {
                setProfileIcon(avatars1);
              }
            }

            const profile = user?.agentData?.agentTelephony?.profile

            if (profile) {
                const types = profile.map(item => item.type);
                setTypes(types)
                const activeProfile = profile.find(item => item.active_profile === true);
                if (activeProfile) {
                setActiveType(activeProfile.type);
                // Store in sessionStorage for HeaderModals
                sessionStorage.setItem("activeLoginType", activeProfile.type);
                // Dispatch custom event for same-tab listeners
                window.dispatchEvent(new CustomEvent('sessionStorageChange', {
                  detail: { key: 'activeLoginType', value: activeProfile.type }
                }));
                } else {
                // Clear if no active profile
                sessionStorage.removeItem("activeLoginType");
                // Dispatch custom event for same-tab listeners
                window.dispatchEvent(new CustomEvent('sessionStorageChange', {
                  detail: { key: 'activeLoginType', value: null }
                }));
                }
            }

            setLoggedInUserDetail(user)
          
            setUserName(user?.username || '');
            setLoggedInUserRole(user?.role);
            if (user?.role === USER_ROLES.COMPANY_ADMIN || user?.role === USER_ROLES.RESELLER || user?.role === USER_ROLES.CALL_CENTRE_ADMIN) {
                setShowCompanyInAvailableCreditsHeading(true);
            } else {
                setShowCompanyInAvailableCreditsHeading(false);
            }

            if (user?.role === USER_ROLES.CALL_CENTRE_AGENT || user?.role === USER_ROLES.CALL_CENTRE_TEAM_LEAD) {
                setHideForCallCenter(true);
            } else {
                setHideForCallCenter(false);
            }
            setUserRoleLabel(USER_ROLES_MAP_PROFILE[user?.role] || '');
            setIsSuperAdmin(user?.role === USER_ROLES.SUPERADMIN);
            setUserId(user?.id);

            if (user.id && (user?.role === USER_ROLES.COMPANY_ADMIN || user?.role === USER_ROLES.RESELLER || user?.role === USER_ROLES.CALL_CENTRE_ADMIN)) {
              let apiUrl = API_COMPANY_PROFILE.replace(":id", user?.assignedCompany?.id);
                getApiCall(apiUrl, {})
                .then((resp) => {
                    setTtsCredits(resp?.tts_credits || "0.00");
                    setUserCredits(resp?.credits_available || "0.00");
                })
                .catch(onError)
            }

            // if (user.id && user?.role !== USER_ROLES.COMPANY_ADMIN) {
            //     let apiUrl = API_COMPANY_PROFILE.replace(":id", user?.assignedCompany?.id);
            //     getApiCall(apiUrl, {})
            //     .then((resp) => {
            //         setUserCredits(resp?.credits_available || "0.00");
            //         setTtsCredits(resp?.tts_credits || "0.00");
            //     })
            //     .catch(onError)
            //   } else {
            //     setUserCredits(user?.company?.credits_available || "0.00");
            //   }
          };
          

        // fetchUserData().then(() => {
        //   if (loggedInUserRole === USER_ROLES.CALL_CENTRE_AGENT) {
        //     checkAndRestoreBreak();
        //   }
        // })
        fetchUserData().then(checkAndRestoreBreak)
        
        // Initialize activeModals from sessionStorage
        const savedActiveModal = sessionStorage.getItem("activeModal");
        if (savedActiveModal) {
            try {
                const parsed = JSON.parse(savedActiveModal);
                if (Array.isArray(parsed)) {
                    setActiveModals(parsed);
                } else if (typeof parsed === 'string') {
                    setActiveModals([parsed]);
                }
            } catch (e) {
                setActiveModals(savedActiveModal ? [savedActiveModal] : []);
            }
        }
        
        // navbarstylemode
        if (headerNavbar === 'navs-sticky' || headerNavbar === 'nav-glass') {
            window.onscroll = () => {
                if (document.documentElement.scrollTop > 50) {
                    document.getElementsByTagName('nav')[0].classList.add('menu-sticky')
                } else {
                    document.getElementsByTagName('nav')[0].classList.remove('menu-sticky')
                }
            }
        }

     }, [])






     // Listen for sessionStorage changes to sync modal states
     useEffect(() => {
         const handleStorageChange = (e) => {
             // Handle both storage events (cross-tab) and custom events (same-tab)
             const key = e.key || (e.detail && e.detail.key);
             
             if (key === "activeModal") {
                 const savedActiveModal = sessionStorage.getItem("activeModal");
                 if (savedActiveModal) {
                     try {
                         const parsed = JSON.parse(savedActiveModal);
                         if (Array.isArray(parsed)) {
                             setActiveModals(parsed);
                         } else if (typeof parsed === 'string') {
                             setActiveModals([parsed]);
                         }
                     } catch (e) {
                         setActiveModals(savedActiveModal ? [savedActiveModal] : []);
                     }
                 } else {
                     setActiveModals([]);
                 }
             }
         };

         // Add storage event listener
         window.addEventListener('storage', handleStorageChange);
         
         // Also add a custom event listener for same-tab updates
         window.addEventListener('sessionStorageChange', handleStorageChange);

         return () => {
             window.removeEventListener('storage', handleStorageChange);
             window.removeEventListener('sessionStorageChange', handleStorageChange);
         };
     }, []);

   const minisidebar =() =>{
       document.getElementsByTagName('ASIDE')[0].classList.toggle('sidebar-mini')
   }


   function onError(err){
        console.log(err);
   }

   async function logout() {
    try {
        // Check if agent is logged in from Soft Phone, Mobile, or WEBRTC
        if (activeType && (activeType === "Soft Phone" || activeType === "Mobile" || activeType === "WEBRTC")) {
            toast.error(`Agent is logged in from ${activeType}. Please logout from ${activeType} first.`);
            return;
        }

        let userStack = await AsyncStorage.getItem('userStack');
        userStack = userStack ? JSON.parse(userStack) : [];

        // Always call logout API
        await postApiCall(`${API_USER_LOGOUT}/${userId}`);

        await AsyncStorage.multiRemove([
        'showPhone', 'showHistory', 'showForm',
        'positionPhone', 'positionHistory', 'positionForm'
        ]);

        if (timerRef.current) {
         clearInterval(timerRef.current);
          timerRef.current = null;
        }
        setLoginTime(0);
        setIdleTime(0);

        await AsyncStorage.multiRemove(['loginTimestamp', 'idleTimestamp']);
        
        if (userStack.length > 0) {
            const switchedBack = await switchBackUser();

            if (switchedBack) {
                window.location.href = `/${ROUTES.DASHBOARD}`;
            } else {
                console.log("Failed to switch back user");
            }
        } else {
            await logoutUser();
            clearUser();
            await AsyncStorage.removeItem('userStack');
            window.location.href = `/${ROUTES.LOGIN}`;
        }
    } catch (error) {
        if (error.includes("TokenExpiredError")) {
            AsyncStorage.clear()
                .then(() => {
                setTimeout(() => {
                    navigate(`/${ROUTES.LOGIN}`);
                    setShowToast(false); 
                    }, 1000);
            })
            // setToastProps({ message: "Session Expired", type: "danger" });
          toast.error("Session Expired");
        }
        // setToastProps({ message: error, type: "danger" });
          toast.error(error);
        console.error('Logout error:', error);
     }
    }

    async function loginAs(type) {
        try {
            const params = {
                type: type
            }
            const resp = await postApiCall(`${API_USER_LOGIN_AS}/${userId}`, params);
            //update asyncStorage
            const rawUser = await AsyncStorage.getItem('user');
            let user = rawUser ? JSON.parse(rawUser) : null;

            if (user && user.agentData?.agentTelephony?.profile) {
              user.agentData.agentTelephony.profile = user.agentData.agentTelephony.profile.map(p => ({
                ...p,
                active_profile: p.type === type 
              }));
            }
            await AsyncStorage.setItem('user', JSON.stringify(user));
            if (type === "WEBRTC" || type === "Soft Phone") {
              // navigate(`/${ROUTES.DASHBOARD}`);
              // window.location.href = `/${ROUTES.DASHBOARD}`;
              // window.location.reload();
              // const hiddenButton = document.createElement("button");
              // hiddenButton.className = "keypadConnect2";
              // hiddenButton.style.display = "none"; 
              // document.body.appendChild(hiddenButton);

              require("../CallIcon/demo-1");
              // sessionStorage.setItem("showWebrtc", "YES");
            
              const buttonObj = document.getElementsByClassName("keypadConnect2");
              for(let o of buttonObj){
                              o.click();
              }


              //hiddenButton.click();
              handleButtonClick("WEB");
            }
            toast.success(`Logged In as: ${type}`);
            // setToastProps({ type: 'success', message: `Logged In as: ${type}` });

            setShowToast(true);
            setActiveType(type);
            // Store activeType in sessionStorage for HeaderModals to access
            sessionStorage.setItem("activeLoginType", type);
            // Dispatch custom event for same-tab listeners
            window.dispatchEvent(new CustomEvent('sessionStorageChange', {
              detail: { key: 'activeLoginType', value: type }
            }));
            setShowModel(false)
          
        } catch (error) {
            // setToastProps({ type: 'danger', message: error || `Error while Logged In as: ${activeType}` });
          toast.error(error || `Error while Logged In as: ${activeType}`);
            setShowToast(true);
            console.error('LoginAs error:', error);
        }
    }

    async function logoutAs(type) {
        try {
            const params = {
                type: type
            }
            const resp = await postApiCall(`${API_USER_LOGOUT_FROM}/${userId}`, params);
            // Update AsyncStorage
            const rawUser = await AsyncStorage.getItem('user');
            let user = rawUser ? JSON.parse(rawUser) : null;

            if (user && user.agentData?.agentTelephony?.profile) {
              user.agentData.agentTelephony.profile = user.agentData.agentTelephony.profile.map(p => ({
                ...p,
                active_profile: p.type === type ? false : p.active_profile
              }));

              await AsyncStorage.setItem('user', JSON.stringify(user));
            }
            
          toast.success(`Logged Out From: ${activeType}`);
          if (type === "WEBRTC" || type === "Soft Phone") {
              // navigate(`/${ROUTES.DASHBOARD}`);
              // window.location.href = `/${ROUTES.DASHBOARD}`;
              // window.location.reload();

              // const hiddenButton = document.createElement("button");
              // hiddenButton.className = "disconnect2";
              // hiddenButton.style.display = "none"; 
              // document.body.appendChild(hiddenButton);

              require("../CallIcon/demo-1");
              sessionStorage.setItem("showWebrtc", "NO");
              const modals = JSON.parse(sessionStorage.getItem("activeModal") || "[]");
              const updatedModals = modals.filter(modal => modal !== "WEB");
              sessionStorage.setItem("activeModal", JSON.stringify(updatedModals));

              const buttonObj = document.getElementsByClassName("disconnect2");
              for(let o of buttonObj){
                              o.click();
              }

               

              //hiddenButton.click();
            }
            setShowToast(true);
            const activeProfile = resp.find(item => item.type === true);
            const newActiveType = activeProfile?.type || null;
            setActiveType(newActiveType);
            // Update sessionStorage when activeType changes
            if (newActiveType) {
                sessionStorage.setItem("activeLoginType", newActiveType);
                // Dispatch custom event for same-tab listeners
                window.dispatchEvent(new CustomEvent('sessionStorageChange', {
                  detail: { key: 'activeLoginType', value: newActiveType }
                }));
            } else {
                sessionStorage.removeItem("activeLoginType");
                // Dispatch custom event for same-tab listeners
                window.dispatchEvent(new CustomEvent('sessionStorageChange', {
                  detail: { key: 'activeLoginType', value: null }
                }));
            }
            
            // Close the WebRTC Phone modal when logging out from Soft Phone, Mobile, or WEBRTC
            if (type === "Soft Phone" || type === "Mobile" || type === "WEBRTC") {
                setActiveModals(prev => {
                    const newModals = prev.filter(modal => modal !== "WEB");
                    // Update sessionStorage
                    if (newModals.length > 0) {
                        sessionStorage.setItem("activeModal", JSON.stringify(newModals));
                    } else {
                        sessionStorage.removeItem("activeModal");
                    }
                    return newModals;
                });
            };
            
            // Close the WebRTC Phone modal when logging out from Soft Phone, Mobile, or WEBRTC
            if (type === "Soft Phone" || type === "Mobile" || type === "WEBRTC") {
                setActiveModals(prev => {
                    const newModals = prev.filter(modal => modal !== "WEB");
                    // Update sessionStorage
                    if (newModals.length > 0) {
                        sessionStorage.setItem("activeModal", JSON.stringify(newModals));
                    } else {
                        sessionStorage.removeItem("activeModal");
                    }
                    return newModals;
                });
            }
        } catch (error) {
            // setToastProps({ type: 'danger', message: `Error while Logged Out From: ${activeType}` });
          toast.error(`Error while Logged Out From: ${activeType}`);
            setShowToast(true);
        }
    }

   async function switchOut(){

        switchBack()
        .then( () => {
            //navigate(`/${ROUTES.SWITCH_ACCOUNT_LOADER}`);
            window.location.href = ROUTES.SWITCH_ACCOUNT_LOADER;
        } )
        .catch(onError);

   }

   useEffect(() => {
       getApiCall(API_BREAK_LIST, {}).then(onListSuccess).catch(onError);
     }, []);

  function onListSuccess(resp) {
    setBreaksData(resp);
  }

    const buttonStyle = (color, isActive) => ({
        border: "none",
        width: "48px",
        height: "42px",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: isActive ? color : "transparent",
        transition: "transform 0.3s",
        cursor: "pointer",
        marginBottom: "0px",
        marginRight: "5px",
        transform: isActive ? "scale(1.05)" : "scale(1)",
    });

    const handleButtonClick = (modalType) => {
        setActiveModals(prev => {
            const isActive = prev.includes(modalType);
            let newModals;
            
            if (isActive) {
                // Remove the modal if it's already active
                newModals = prev.filter(modal => modal !== modalType);
            } else {
                // Add the modal if it's not active
                newModals = [...prev, modalType];
            }
            
            // Save to sessionStorage for HeaderModals to read
            sessionStorage.setItem("activeModal", JSON.stringify(newModals));
            
            // Show the phone panel if not already shown (for WEB modal)
            if (modalType === "WEB" && !sessionStorage.getItem("showPhone")) {
                sessionStorage.setItem("showPhone", "true");
            }
            
            return newModals;
        });
        
        // Update the single activeModal for backward compatibility
        setActiveModal(modalType);
    };

    useEffect(() => {
      if (loggedInUserRole === USER_ROLES.CALL_CENTRE_AGENT) {
        if (userStatus === "AVAILABLE") {
          setDotColor("#28a745");
        } else if (userStatus === "BREAK") {
          setDotColor(breakExceeded ? "#dc3545" : "#ffc107");
        } else {
          setDotColor("#6c757d");
        }
      } else {
        setDotColor("#28a745")
      }

    }, [userStatus, breakExceeded]);


    return (
        <>
        <Fragment>
            <Navbar expand="lg" variant="light" className={`nav iq-navbar ${headerNavbar} ${navbarHide.join(" ")}`} style={{
              // background: "linear-gradient(45deg, #08063d, rgb(7,64,141))" ,
              backgroundColor: "#04005a"
              }}>
                <Container fluid className="navbar-inner">
                    <Link to="/dashboard" className="navbar-brand">
                        <Logo color={true} />
                        <h4 className="logo-title" style={{ color: "white", fontSize: "17px" }}>Cloud Telephony</h4>
                    </Link>
                    <div className="sidebar-toggle" data-toggle="sidebar" data-active="true" onClick={minisidebar}>
                        <i className="icon">
                            <svg width="20px" height="20px" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                            </svg>
                        </i>
                    </div>
                    {/* <div className="input-group search-input">
                        <span className="input-group-text" id="search-input">
                            <svg width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="11.7669" cy="11.7666" r="8.98856" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></circle>
                                <path d="M18.0186 18.4851L21.5426 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                        </span>
                        <input type="search" className="form-control" placeholder="Search..."/>
                    </div> */}
                    <Navbar.Toggle aria-controls="navbarSupportedContent">
                        <span className="navbar-toggler-icon">
                            <span className="mt-2 navbar-toggler-bar bar1"></span>
                            <span className="navbar-toggler-bar bar2"></span>
                            <span className="navbar-toggler-bar bar3"></span>
                        </span>
                    </Navbar.Toggle>
                    
                    <Navbar.Collapse  id="navbarSupportedContent">
                        <Nav as="ul" className="mb-2 ms-auto navbar-list mb-lg-0 align-items-center">
                            {(!isSuperAdmin && !hideForCallCenter) && <div style={{ marginRight: "30px" }}>
                              <h6 className='mb-0 caption-title' style={{color: 'white'}}>{showCompanyInAvailableCreditsHeading ? "Comp": null} Voice Credits: {userCredits}</h6>
                            </div>
                            }
                            {(loggedInUserRole !== USER_ROLES.SUPERADMIN && loggedInUserRole !== USER_ROLES.CALL_CENTRE_AGENT && loggedInUserRole !== USER_ROLES.CALL_CENTRE_TEAM_LEAD) && <div style={{ marginRight: "30px", display: "flex", alignItems: "center" }}>
                              <h6 className='mb-0 caption-title' style={{color: 'white', marginRight: "10px"}}>Comp TTS Credits: {ttsCredits}</h6>
                              <div className=' rounded-full refresh-button' style={{
                    borderRadius:"50%",
                    padding:"8px",
                    // background:"linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    // boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                    transition: "all 0.3s ease",
                    border: "2px solid rgba(255, 255, 255, 0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  onMouseOver={(e) => {
                    if (!isRefreshingCredits) {
                      e.currentTarget.style.transform = "scale(1.1)";
                      // e.currentTarget.style.boxShadow = "0 6px 20px rgba(102, 126, 234, 0.6)";
                    }
                  }}
                  onMouseOut={(e) => {
                    if (!isRefreshingCredits) {
                      e.currentTarget.style.transform = "scale(1)";
                      // e.currentTarget.style.boxShadow = "0 4px 15px rgba(102, 126, 234, 0.4)";
                    }
                  }}>
                    <ArrowClockwise
                      size={17}
                      color="white "
                      className=''
                      style={{
                        cursor: isRefreshingCredits ? "not-allowed" : "pointer",
                        opacity: isRefreshingCredits ? 0.5 : 1,
                        animation: isRefreshingCredits ? "spin 1s linear infinite" : "none"
                      }}
                      onClick={refreshCredits}
                    />
                  </div>

                            </div>
                            }

                            {loggedInUserRole && loggedInUserRole === USER_ROLES.CALL_CENTRE_AGENT && (
                                <Dropdown as="li" className="nav-item me-2">

                                    <div style={{ display: "flex", alignItems: "center" }} title="Login/Logout Options">
                                        <button 
                                            style={buttonStyle('#ffffffff', activeModals.includes("WEB"))} 
                                            onClick={() => handleButtonClick("WEB")}
                                            title="WebRTC phone"
                                        >
                                            <IoCall style={{ fontSize: "24px" }} color={activeModals.includes("WEB") ? "rgb(8, 29, 93)" : "white"}/> 
                                        </button>
                                        <button 
                                            style={buttonStyle('#ffffffff', activeModals.includes("AGENT_TOOLS"))} 
                                            onClick={() => handleButtonClick("AGENT_TOOLS")}
                                            title="Agent tool"
                                        >
                                            <FaTasks style={{ fontSize: "24px" }} color={activeModals.includes("AGENT_TOOLS") ? "rgb(8, 29, 93)" : "white"}/>
                                        </button>
                                        <Dropdown.Toggle
                                        id="navbarDropdownCalls"
                                        variant="dark"
                                        className="px-4 py-2 rounded border-0"
                                        style={{ backgroundColor: "#3f608f", color: "white" }}
                                        >
                                        {/* {activeType ? `Logout from: ${activeType}` : "Login to take calls"} */}
                                        {activeType ? (
                                          <>Logout from: <strong style={{ color: "#FF3D00" }}>{activeType}</strong></>
                                        ) : (
                                          "Login to take calls"
                                        )}
                                        </Dropdown.Toggle>
                                    </div>
                                    <Dropdown.Menu className="dropdown-menu-end" aria-labelledby="navbarDropdownCalls" style={{ height: 'auto', width: '200px' }}>
                                   {['Soft Phone', 'Mobile', 'WEBRTC'].map((type) => {
                                        if (!types.includes(type)) return null;

                                        const isActive = activeType === type;

                                        return (
                                            <Dropdown.Item
                                            key={type}
                                            as="div"
                                            className="d-flex justify-content-between align-items-center"
                                            style={{ padding: '5px 7px', borderRadius: '6px', marginTop: '8px' }}
                                            >
                                            <div>
                                                <b>{type === 'Soft Phone' ? 'Soft Phone' : type === 'Mobile' ? 'Mobile' : 'WEBRTC'}</b><br />
                                            </div>

                                            <label className="switch ms-3">
                                                <input
                                                type="checkbox"
                                                checked={isActive}
                                                    disabled={false}
                                                className={!isActive ? 'toggle-red' : ''}
                                                onChange={async () => {
                                                    if (isActive) {
                                                        // If already active, logout
                                                        await logoutAs(type);
                                                    } else {
                                                        // If trying to activate a new type
                                                        // First logout from current active type (if any)
                                                        if (activeType && activeType !== type) {
                                                            await logoutAs(activeType);
                                                        }
                                                        // Then login to the new type
                                                        await loginAs(type);
                                                    }
                                                }}
                                                />
                                                <span className="slider"></span>
                                            </label>
                                            </Dropdown.Item>
                                        );
                                    })}

                                    </Dropdown.Menu>
                                </Dropdown>
                            )}


                            {loggedInUserRole === USER_ROLES.CALL_CENTRE_AGENT && (
                              <>
                                {(countdown !== null && countdown > 0 && userStatus === 'BREAK') && (
                                  <div
                                    className="d-flex align-items-center gap-2"
                                    style={{
                                      backgroundColor: "#f70303ff",
                                      border: "1px solid #f70303ff",
                                      borderRadius: "999px",
                                      padding: "6px 14px",
                                      fontSize: "14px",
                                      fontWeight: 600,
                                      color: "#faf9f7ff",
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                      cursor: "pointer",
                                       marginRight: '5px'
                                    }}
                                    title="Break Remaining"
                                    // onClick={() => setShowCancelModal(true)}
                                  >
                                    <FaClock size={14} />
                                    <span>Break</span>
                                    <span style={{ fontWeight: 700 , minWidth: '50px', display: 'inline-block', textAlign: 'right' }}>
                                      {formatTime(countdown)}
                                    </span>
                                  </div>
                                )}
                                {(breakExceeded &&  userStatus === 'BREAK') && (
                                  <div
                                    className="d-flex align-items-center gap-2"
                                    style={{
                                      backgroundColor: "#fdecea",
                                      border: "1px solid #dc3545",
                                      borderRadius: "999px",
                                      padding: "6px 14px",
                                      fontSize: "14px",
                                      fontWeight: 600,
                                      color: "#842029",
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                      cursor: "pointer",
                                       marginRight: '5px'
                                    }}
                                    title="Break Time Exceeded"
                                  >
                                    <FaExclamationTriangle size={14} />
                                    <span>Break Exceeded</span>
                                  </div>
                                )}
                                    <div
                                      className="d-flex align-items-center gap-2"
                                      style={{
                                        backgroundColor: "#fce28aff",
                                        border: "1px solid #ffc107",
                                        borderRadius: "999px",
                                        padding: "6px 14px",
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        color: "#856404",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                        cursor: "pointer",
                                        marginRight: '5px'
                                      }}
                                      title="Idle Time"
                                    >
                                      <FaClock size={14} />
                                      <span>Idle</span>
                                      <span style={{ fontWeight: 700 , minWidth: '50px', display: 'inline-block', textAlign: 'right' }}>
                                        {formatTime(idleTime)}
                                      </span>
                                    </div>
                              </>
                            )}

                                    <div
                                      className="d-flex align-items-center gap-2"
                                      style={{
                                        backgroundColor: "#4bb567ff",
                                        border: "1px solid #4bb567ff",
                                        borderRadius: "999px",
                                        padding: "6px 14px",
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        color: "#fffdf8f5",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                        cursor: "pointer",
                                      }}
                                      title="Online Time"
                                      // onClick={() => setShowCancelModal(true)}
                                    >
                                      <FaClock size={14} />
                                      <span>Online</span>
                                      <span style={{ fontWeight: 700, minWidth: '50px', display: 'inline-block', textAlign: 'right'  }}>
                                        {formatTime(loginTime)}
                                      </span>
                                    </div>


                            <Dropdown as="li" className="nav-item">
                                {/* <Dropdown.Toggle as={CustomToggle} variant=" nav-link py-0 d-flex align-items-center" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <img src={avatars1} alt="User-Profile" className="theme-color-default-img img-fluid avatar avatar-50 avatar-rounded"/>
                                    <img src={avatars2} alt="User-Profile" className="theme-color-purple-img img-fluid avatar avatar-50 avatar-rounded"/>
                                    <img src={avatars3} alt="User-Profile" className="theme-color-blue-img img-fluid avatar avatar-50 avatar-rounded"/>
                                    <img src={avatars5} alt="User-Profile" className="theme-color-green-img img-fluid avatar avatar-50 avatar-rounded"/>
                                    <img src={avatars6}alt="User-Profile" className="theme-color-yellow-img img-fluid avatar avatar-50 avatar-rounded"/>
                                    <img src={avatars4} alt="User-Profile" className="theme-color-pink-img img-fluid avatar avatar-50 avatar-rounded"/>
                                    <div className="caption ms-3 d-none d-md-block ">
                                        <p className="mb-0 caption-sub-title" style={{color: 'white'}}>{userRoleLabel}</p>
                                        <h6 className="mb-0 caption-title" style={{color: 'white'}}>{userName}</h6>
                                    </div>
                                </Dropdown.Toggle> */}
                                <Dropdown.Toggle
                                  as={CustomToggle}
                                  variant="nav-link py-0 d-flex align-items-center"
                                  id="navbarDropdown"
                                >
                                  <div style={{ position: "relative" }} title="User Profile">
                                    <img
                                      src={profileIcon}
                                      alt="User-Profile"
                                      className="img-fluid avatar avatar-50 avatar-rounded"
                                    />

                                    {/* STATUS BADGE */}
                                    <span
                                      style={{
                                        position: "absolute",
                                        bottom: "1px",
                                        right: "1px",
                                        width: "18px",
                                        height: "18px",
                                        borderRadius: "50%",
                                        backgroundColor: dotColor,
                                        // backgroundColor: 'green',
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        border: "2px solid white",
                                      }}
                                    >
                                     {breakExceeded ? <FaMinus style={{ color: "white", fontSize: "9px" }} /> 
                                     : <FaCheck style={{ color: "white", fontSize: "9px" }} />} 
                                    </span>
                                  </div>

                                  <div className="caption ms-3 d-none d-md-block" title="User Profile">
                                    <p className="mb-0 caption-sub-title" style={{ color: "white", fontStyle: "italic" }}>
                                      Role: {userRoleLabel}
                                    </p>
                                    <h6 className="mb-0 caption-title" style={{ color: "white" }}>
                                      {userName}
                                    </h6>
                                  </div>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="dropdown-menu-end p-2 user-dropdown">
                                  
                                  {/* User Header */}
                                  <div className="d-flex align-items-center mb-3">
                                    <div className="user-avatar me-2">
                                    <div className="avatar-circle">
                                      <img
                                        src={profileIcon}
                                        alt="User-Profile"
                                        className="avatar-img"
                                      />
                                    </div>

                                    </div>
                                    <div className="user-info">
                                      <div className="fw-bold user-name">
                                        {loggedInUserDetail?.username}
                                      </div>

                                      <div className="text-muted small" style={{ fontStyle: "italic" }}>
                                        Role: {" "}
                                        {USER_ROLES_MAP_PROFILE[loggedInUserDetail?.role] || ''}
                                      </div>

                                      <div className="text-muted small user-email">
                                        {loggedInUserDetail?.email}
                                      </div>
                                    </div>

                                  </div>

                                  <Dropdown.Divider />

                                  {loggedInUserRole === USER_ROLES.CALL_CENTRE_AGENT && (
                                    <Dropdown.Item
                                      onClick={() => {
                                        if (userStatus === "AVAILABLE") {
                                          handleShow();
                                        } else {
                                          setShowCancelModal(true);
                                        }
                                      }}
                                      className="d-flex align-items-center px-0 py-1"
                                      style={{ fontSize: "16px" }}
                                    >
                                      <FaRegPauseCircle className="me-1" style={{ fontSize: "16px" }} />
                                      {userStatus === "AVAILABLE" ? "Set Break" : "Remove Break"}
                                    </Dropdown.Item>

                                  )}


                                  <Dropdown.Item
                                    as={Link}
                                    to={`/${ROUTES.PROFILE}`}
                                    className="d-flex align-items-center px-0 py-1"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <FaRegUser className="me-1" style={{fontSize: "16px"}}/> My account
                                  </Dropdown.Item>

                                  <Dropdown.Item
                                    onClick={logout}
                                    className="d-flex align-items-center text-danger px-0 py-1"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <FaSignOutAlt className="me-1" style={{fontSize: "16px"}}/> Sign Out
                                  </Dropdown.Item>

                                  {loggedInUserRole === USER_ROLES.CALL_CENTRE_AGENT && (
                                    <>
                                      <Dropdown.Divider />
                                      <div className="small text-muted">
                                        <div
                                          style={{ position: "relative", display: "inline-block" }}
                                          onMouseEnter={() => setShowQueueTooltip(true)}
                                          onMouseLeave={() => setShowQueueTooltip(false)}
                                        >
                                          <div
                                            className="text-primary"
                                            style={{
                                              cursor: agentGroups.length > 0 ? "pointer" : "default",
                                              fontSize: "0.85rem",
                                              fontWeight: 600,
                                              display: "inline-flex",
                                              alignItems: "center",
                                              gap: "6px"
                                            }}
                                          >
                                            <span style={{ color: "#4c4a4aff" }}>
                                              Assigned Queue:
                                            </span>
                                            <span
                                            >
                                              View ({agentGroups?.length})
                                            </span>
                                          </div>

                                          {/* SAME TOOLTIP */}
                                          {showQueueTooltip && agentGroups.length > 0 && (
                                            <div
                                              style={{
                                                position: "absolute",
                                                top: "120%",
                                                right: 0,
                                                backgroundColor: "#fff",
                                                borderRadius: "8px",
                                                boxShadow: "0 16px 32px rgba(0,0,0,0.18)",
                                                padding: "12px",
                                                minWidth: "410px",
                                                zIndex: 9999,
                                                border: "1px solid rgba(0,0,0,0.07)",
                                              }}
                                              onMouseEnter={() => setShowQueueTooltip(true)}
                                              onMouseLeave={() => setShowQueueTooltip(false)}
                                            >
                                          
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "space-between",
                                                  marginBottom: 6,
                                                  borderBottom: "1px solid rgba(0,0,0,0.08)",
                                                  paddingBottom: 4,
                                                }}
                                              >
                                                <div style={{ fontSize: "0.8rem", fontWeight: 600 }}>
                                                  Assigned Groups
                                                </div>

                                                {agentGroups.length > pageSize && (
                                                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                    <button
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        setQueuePage((p) => Math.max(0, p - 1));
                                                      }}
                                                      disabled={!hasPrev}
                                                      style={{ border: "none", background: "transparent" }}
                                                    >
                                                      <FaChevronLeft />
                                                    </button>
                                                    <span style={{ fontSize: "0.75rem" }}>
                                                      {queuePage + 1}/{totalPages}
                                                    </span>
                                                    <button
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        setQueuePage((p) => Math.min(totalPages - 1, p + 1));
                                                      }}
                                                      disabled={!hasNext}
                                                      style={{ border: "none", background: "transparent" }}
                                                    >
                                                      <FaChevronRight />
                                                    </button>
                                                  </div>
                                                )}
                                              </div>

                                              {paginatedGroups.map((grp, idx) => (
                                                <div key={idx} style={{ padding: "6px 0" }}>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "12px",
                                                      flexWrap: "wrap",
                                                    }}
                                                  >
                                                    <div style={{ fontWeight: 600 }}>
                                                      {grp.group_name}
                                                    </div>

                                                    <div style={{ fontSize: "0.75rem", color: "#555" }}>
                                                      {grp.schedule?.start_time} - {grp.schedule?.end_time}
                                                    </div>
                                                  </div>

                                                  {/* Second row */}
                                                  <div style={{ fontSize: "0.72rem", color: "#777" }}>
                                                    {grp.schedule?.week_days?.join(", ")}
                                                  </div>
                                                </div>

                                              ))}
                                            </div>
                                          )}
                                        </div>

                                        {/* <div>Shift: -</div>
                                        <div>
                                          Last Login:{" "}
                                          <span className="text-primary">
                                            30 Dec 2025, 11:41:15 AM
                                          </span>
                                        </div> */}
                                      </div>
                                    </>
                                  )}
                                </Dropdown.Menu>

                            </Dropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </Fragment>

        <Modal show={showBreakModal} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Choose Break</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="breakSelect">
              <Form.Label>Select a break:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
              <Form.Select
                value={selectedBreakId}
                onChange={(e) => setSelectedBreakId(e.target.value)}
              >
                <option value="">Select Break</option>
                {breaksData.map((brk) => (
                  <option key={brk.id} value={brk.id}>
                    {brk.title} - ({brk.duration} Mins)
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose} style={{ marginRight: "20px", backgroundColor: "grey" }}>
              Cancel
            </Button>
            <Button variant="primary" style={{ backgroundColor: "#1789e5ff" }} onClick={handleConfirm}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showCancelModal} onHide={() => setShowCancelModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Cancel Break</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to cancel the break?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCancelModal(false)} style={{ marginRight: "20px", backgroundColor: "grey" }}>
              No
            </Button>
            <Button variant="danger" onClick={cancelBreak} style={{ backgroundColor: "#1789e5ff" }}>
              Yes, Cancel
            </Button>
          </Modal.Footer>
        </Modal>

          <div style={{display: "none" }}>
          <button className="disconnect2"></button>
          <button className="keypadConnect2"></button>
          </div>
                {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps}/> */}

                  </>
              )
          })

export default Header
  